var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 346,
    viewBox: "0 0 400 346",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4853 3.51472C14.7357 1.26428 17.788 0 20.9706 0H388C394.627 0 400 5.37258 400 12V334C400 340.627 394.627 346 388 346H12C5.37257 346 0 340.627 0 334V114V57V28.5V20.9706C0 17.788 1.26428 14.7357 3.51472 12.4853L12.4853 3.51472Z",
    fill: "#0F161B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardImg);
export default __webpack_public_path__ + "static/media/rewardImg.8c85818135b98c9a39253bc059332f70.svg";
export { ForwardRef as ReactComponent };